import React from 'react'
import PropTypes from 'prop-types'

const Tab = ({id, title, tabActive, setTabActive}) => {
  return (
    <div 
      className={`tab tab--${tabActive === id ? 'actived' : 'disabled'}`}
      onClick={() => setTabActive(id)}>
        <p>{title}</p>
    </div>
  )
}

Tab.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  tabActive: PropTypes.number.isRequired,
  setTabActive: PropTypes.func.isRequired
}

export default Tab